import { render, staticRenderFns } from "./AddBlogSidebar.vue?vue&type=template&id=bc35ef0e&scoped=true&"
import script from "./AddBlogSidebar.vue?vue&type=script&lang=js&"
export * from "./AddBlogSidebar.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./AddBlogSidebar.vue?vue&type=style&index=1&id=bc35ef0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc35ef0e",
  null
  
)

export default component.exports